module.exports = __webpack_public_path__ + "static/media/station.12def044.svg";